import { proveedorRoutes } from './proveedor/proveedor.routes';
import { Routes, CanMatchFn } from '@angular/router';
import { PageNotFoundComponent } from './_views/page-not-found/page-not-found.component';
import { authGuard } from './services/auth/auth.guard';
import { UnauthorizedComponent } from './_views/unauthorized/unauthorized.component';
import { BaseLayoutComponent } from './layout/base-layout/base-layout.component';
import { environment } from '../environments/environment';
import { ViewModeService } from './services/view-mode/view-mode.service';
import { inject } from '@angular/core';
import { PageRedirectComponent } from './components/page-redirect/page-redirect.component';
import { MENUS_HOME, MENU_CONFIGURACION } from './_models/configuration.model';
import { verMenu } from './services/auth/menu.guard';

export const canMatchClientView: CanMatchFn = () => {
  const viewModeService = inject(ViewModeService);
  return viewModeService.isClientView();
};

export const canMatchSupplierView: CanMatchFn = () => {
  const viewModeService = inject(ViewModeService);
  return viewModeService.isSupplierView();
};

export const routes: Routes = [
  // { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  
  // Ruta pública para registro externo con token
  {
    path: 'create-supplier/:tokenId',
    loadComponent: () =>
      import('./_views/create-supplier-complete/create-supplier-complete.component').then((m) => m.CreateSupplierCompleteComponent),
  },
  
  {
    path: 'pages',
    component: BaseLayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        component: PageRedirectComponent,
      },
      {
        path: 'home',
        canMatch: [canMatchClientView, verMenu(...MENUS_HOME)],
        loadComponent: () =>
          import('./_views/home-dashboard/home-dashboard.component').then((m) => m.HomeDashboardComponent),
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'registro' },
          {
            path: 'registro',
            canMatch: [verMenu('home_registro')],
            loadComponent: () => import('./_views/home-dashboard/registro-tab.component').then((m) => m.RegistroTabComponent),
          },
          {
            path: 'transacciones',
            canMatch: [verMenu('home_transacciones')],
            loadComponent: () => import('./_views/home-dashboard/transacciones-tab.component').then((m) => m.TransaccionesTabComponent),
          },
          {
            path: 'evaluaciones',
            canMatch: [verMenu('home_evaluaciones')],
            loadComponent: () => import('./_views/home-dashboard/evaluaciones-tab.component').then((m) => m.EvaluacionesTabComponent),
          },
        ],
      },
      /*{
        path: 'business-partners',
        loadChildren: () =>
          import('./_views/base/home/home.module').then((m) => m.HomeModule),
      },*/
      {
        path: 'business-partners',
        canMatch: [canMatchClientView],
        loadChildren: () =>
          import('./_views/business-partners/home/home.module').then((m) => m.HomeModule),
      },
      /*{
        path: 'dashboard',
        loadChildren: () =>
          import('./_views/dashboard/home/home.module').then((m) => m.HomeModule),
      },*/
      {
        path: 'directorio',
        canMatch: [canMatchClientView, verMenu('directorio')],
        loadComponent: () =>
          import('./_views/business-partners/directory/directory.component').then((m) => m.DirectoryComponent),
      },
      {
        path: 'acreditaciones',
        canMatch: [canMatchClientView, verMenu('acreditaciones')],
        loadComponent: () => import('./_views/acreditaciones/acreditaciones.component').then((m) => m.AcreditacionesComponent),
      },
      {
        path: 'acreditaciones/:id',
        canMatch: [canMatchClientView, verMenu('acreditaciones')],
        loadComponent: () => import('./_views/acreditaciones/ficha/ficha-acreditacion.component').then((m) => m.FichaAcreditacionComponent),
      },
      {
        path: 'tasks',
        canMatch: [canMatchClientView],
        loadComponent: () =>
          import('./_views/tasks/home/home.component').then(
            (m) => m.TasksHomeComponent
          ),
      },
      {
        path: 'settings',
        canMatch: [canMatchClientView, verMenu(MENU_CONFIGURACION)],
        loadChildren: () =>
          import('./_views/settings/home/home.module').then(
            (m) => m.HomeModule
          ),
      },
      {
        path: 'information-requests',
        canMatch: [canMatchSupplierView],
        loadChildren: () =>
          import('./_views/information-requests/home/home.module').then(
            (m) => m.HomeModule
          ),
      },
      {
        path: 'shared-information',
        canMatch: [canMatchSupplierView],
        loadChildren: () =>
          import('./_views/shared-information/home/home.module').then(
            (m) => m.HomeModule
          ),
      },
      {
        path: 'detail/:companyId/:identification_number',
        canMatch: [canMatchClientView],
        loadChildren: () =>
          import('./_views/detail/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'create-supplier',
        canMatch: [canMatchClientView],
        loadComponent: () =>
          import('./_views/create-supplier/create-supplier.component').then((m) => m.CreateSupplierComponent),
      },
    ],
  },
  ...proveedorRoutes,
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', component: PageNotFoundComponent },
];
